module.exports = __webpack_public_path__ + "investment-roi.3gCCUdF0.svg";